import DetailedCard from './DetailedCard'

export default DetailedCard
